import { createAction } from '@reduxjs/toolkit';
import { DialogActionTypes } from './dialog.actions.types';
import { IDialogOpenPayload } from './dialog.interface';

export const dialogOpen = createAction<IDialogOpenPayload>(DialogActionTypes.OpenDialog);

export const dialogClose = createAction(DialogActionTypes.CloseDialog);
